import { ChangeDetectorRef, Directive, EmbeddedViewRef, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AsyncState } from '@cawita/core-front/state';
import { Profile } from '@shared/models';
import { SubSink } from 'subsink';
import { LoggedProfileStore, ProfileState } from './logged-profile.store';

export interface ActiveProfileContext {
    $implicit: Profile;
    profile: Profile;
}

@Directive({ selector: '[cwtIfActiveProfile]' })
export class IfActiveProfileDirective implements OnInit, OnDestroy {
    private sub = new SubSink();
    private ctx: ActiveProfileContext = { $implicit: null, profile: null };

    @Input('cwtIfActiveProfileElse') else: TemplateRef<any>;

    constructor(
        protected store: LoggedProfileStore,
        protected tRef: TemplateRef<ActiveProfileContext>,
        protected vcRef: ViewContainerRef,
        protected cdRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.sub.sink = this.store.state$.subscribe((state) => this._onStateChange(state));
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    private _onStateChange(state: ProfileState & AsyncState) {
      this.vcRef.clear();
      if(state.profile) {
        this.ctx.$implicit = this.ctx.profile = state.profile;
        const ref = this.vcRef.createEmbeddedView(this.tRef, this.ctx);
        ref.detectChanges();
      } else if(this.else) {
        const ref = this.vcRef.createEmbeddedView(this.else, {});
        ref.detectChanges();
      }
    }
}